import React from 'react';
import { Modal, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './style.scss';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const LoadingModal = ({
  loading,
  lang
}) => {
  return (<Modal
    centered
    closable={false}
    title={lang === 'en' ? 'System information' : 'Información del sistema'}
    visible={loading}
    cancelButtonProps={{ style: { display: 'none' } }}
    okButtonProps={{ style: { display: 'none' } }}
  >
    <div className="loading-modal-content">
      <Spin indicator={antIcon} />
      {lang === 'en' ?
        <p>Transaction in progress, please wait...</p>
        :
        <p>Transacción en proceso, por favor espere...</p>
      }
    </div>
  </Modal>);
};

export default LoadingModal;